import { makeStyles } from "@material-ui/core";

const linkStyles = makeStyles((theme) => ({
  checked: {
    color: "green",
    marginRight: "5px",
    "&::before": {
      content: '"\\2713"',
    },
  },
  unchecked: {
    color: "red",
    marginRight: "5px",
    "&::before": {
      content: '"\\2716"',
    },
  },
  validations: {
    display: "flex",
    flexDirection: "row",
    borderStyle: "none!important",
  },
}));
export const ValidationsCheck = ({
  validations: { Mayus, Number, Length },
}) => {
  const classes = linkStyles();
  const classLength = Length ? classes.checked : classes.unchecked;
  const classMayus = Mayus ? classes.checked : classes.unchecked;
  const classNumber = Number ? classes.checked : classes.unchecked;

  return (
    <div className={classes.validations}>
      <p className={classMayus}>1 mayúscula</p>
      <p className={classNumber}>1 número</p>
      <p className={classLength}>8 caracteres</p>
    </div>
  );
};
